import { Option, Select } from "@mui/joy";
import { memo, type SetStateAction } from "react";
import {
  type DataRoomListFilter,
  filterOptions,
  filterOptionsMap,
} from "./models";

interface DataRoomsListFilterProps {
  filterKey: DataRoomListFilter["key"];
  setFilterKey: (value: SetStateAction<DataRoomListFilter["key"]>) => void;
}

const DataRoomsListFilter = memo<DataRoomsListFilterProps>(
  ({ filterKey, setFilterKey }) => {
    return (
      <Select
        defaultValue={filterOptionsMap.active.key}
        onChange={(event, value) => {
          setFilterKey(value as DataRoomListFilter["key"]);
        }}
        value={filterKey}
      >
        {filterOptions.map(({ label, key }: DataRoomListFilter) => (
          <Option key={key} value={key}>
            {label}
          </Option>
        ))}
      </Select>
    );
  }
);

DataRoomsListFilter.displayName = "DataRoomsListFilter";

export default DataRoomsListFilter;
